export default function (match) {
  // HomeController
  match('', 'home#index')
  match('home', 'home#index')
  match('mens', 'home#mens')
  match('womens', 'home#womens')

  // Referral logic happens in referral_controller.rb
  // The Header will pick up that this is a referral URL and show a nice little banner for us.
  match('r/:code', 'home#index')

  // PasswordResetsController
  match('reset', 'password_resets#create')
  match('reset/:token', 'password_resets#reset')

  // CollectionsController
  match('collections/:permalink', 'collections#show', { name: 'collection' })
  match('collections/:permalink/:displayGroupName', 'collections#show', {
    name: 'collection',
  })

  // GiftcardsController
  match('redeem', 'giftcards#redeem')
  match('redeem/:token', 'giftcards#redeem')

  // ProductsController
  match('mix-and-match/:productPermalink/:secondaryProductPermalink', 'products#show')
  match('products/:productPermalink', 'products#show')
  match('back-to-work-outfits', 'pages#outfitsRedirect')

  // FactoriesController
  match('factories', 'factories#index')
  match('factories/:permalink', 'factories#details')

  // PagesController
  match('about', 'pages#about')
  match('help', 'pages#help')
  match('careers', 'pages#jobs')
  match('accessibility', 'pages#accessibility')
  match('complete_account', 'pages#completeAccount')
  match('stores(/:store)', 'pages#visitUs')
  match('magic-link-login-error', 'pages#magicLinkLoginError')
  match('builder-test-editor', 'pages#builderTestEditor')

  // SitemapController
  match('sitemap', 'sitemap#collections')
  match('sitemap/products(/:page)', 'sitemap#products')
  match('sitemap/filtered_collections', 'sitemap#filtered')

  // OAuthController
  match('oauth/authorize', 'oauth#authorize')

  // CheckoutController
  match('checkout/shipping', 'checkout#index')
  match('checkout/billing', 'checkout#index')
  match('checkout/email', 'checkout#index')
  match('checkout/account', 'checkout#index')
  match('checkout/review', 'checkout#index')
  match('checkout/route', 'checkout#index')
  match('checkout/preview', 'checkout#index')
  match('checkout/thanks', 'checkout#index')
  match('checkout', 'checkout#index')

  // SearchController
  match('search', 'search#show_v2')

  match('international', 'referrals#land')

  match('invite', 'account#invite')

  match('reset(/:token)', 'pages#reset')

  match('404', 'not_found#index')

  match('*permalink', 'pages#show')
}
